<template>
  <modal @close="close" :show="localShow">
    <v-flex class="ma-1" slot="title">Przypisz grupę</v-flex>

    <v-layout row wrap>
      <v-autocomplete
        label="Grupa"
        v-model="selected"
        item-text="name"
        item-value="id"
        cache-items
        class="mx-3"
        flat
        dense
        hide-no-data
        persistent-hint
        :loading="loading"
        :search-input.sync="search"
        :hint="'Wybierz grupę którą chesz przypisać użytkownikowi ' + userName"
        :items="groups"
      />
    </v-layout>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>
<script>
import { mapState } from 'vuex';

import modal from '@/components/material/Modal';
import { DEFAULT_LIST_COUNT } from '@/utils/constants';

// @vuese
// Modal dodawnia/edycji profilu klienta
// @group Client-Profile
export default {
  components: { modal },
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      selected: undefined,
      loading: false,
      search: '',
      groups: []
    };
  },
  methods: {
    // @vuese
    // Funkcja wywołuje przypisanie grupy do użytkownika
    save() {
      this.$store.dispatch('client/groups/add', { profileId: this.profileId, groupId: this.selected });
      this.close();
    },
    // @vuese
    // Funkcja wywołuje zamknięcie modala
    close() {
      // Zamyka modal
      this.$emit('close');
    },
    // @vuese
    // Funkcja wywołuje pobranie listy grup przez store
    async getList(val) {
      this.loading = true;
      await this.$store.dispatch('groups/list', { start: 0, search: val, order: 'name', auto: false });
      this.loading = false;
    }
  },
  computed: {
    localShow() {
      return this.show;
    },
    ...mapState({
      userName: state => state.client.data.profile.firstName + ' ' + state.client.data.profile.lastName,
      profileId: state => state.client.data.profile.id
    })
  },
  watch: {
    search(val) {
      if (val) {
        this.getList(val);
      }
    },
    '$store.state.groups.list'(val) {
      this.groups = val;
    }
  },
  mounted() {
    this.$store
      .dispatch('groups/list', { start: 0, count: DEFAULT_LIST_COUNT, search: '', order: 'name', auto: false })
      .then(() => (this.groups = this.$store.state.groups.list));
  }
};
</script>
